import { useEffect, useRef } from 'react';

/** Move o foco para o elemento ao montar — usado para anunciar a troca de etapa do fluxo a leitores de tela. */
export function useAutoFocusRef<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    ref.current?.focus();
  }, []);

  return ref;
}
